import {Component, OnDestroy, ViewChild} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription, Subject } from "rxjs";
import { MediaObserver } from "@angular/flex-layout";
import { UserService, UtilService, RoutingHistoryService, TaxonomyService, PermissionService, StoreHelper } from '../services'
import * as _ from 'lodash';
import { filter, first, map, takeUntil, tap } from 'rxjs/operators';
import { ItemEditContextModel, ItemService } from '../services/item.service';

@Component({
    selector: 'picker-container',
    styles: [`
        mat-sidenav.browse-nav {
            width: 300px;
        }

        .big-icon {
            font-size: 20px
        }
        
        .side-menu-button {
            width: 100%;
            text-align: left;
        }

        .side-menu-button h3 {
            margin: 0px 0px 5px 0px;
        }

        .selected-side-menu-button {
            background: #D7D7D7;
        }

        .category-menu-button {
            text-align: left;
            width: 100%;
            font-size: 18px;
            padding-left: 60px;
            font-size: 15px;
        }

        .menuButtonHolder {
            min-height: 40px;
            max-height: 40px;
        }

        .menu-button {
            padding: 0px;
            min-width: 35px;
        }

        .unauth-menu-button {
            padding: 8px;
            min-width: 35px;
        }

        .left-menu-button {
            margin-right: 10px;
        }

        .tall-sidenav {
            height: calc(100vh - 65px) !important;
            min-height: calc(100vh - 65px) !important;
        }

        .short-sidenav {
            height: calc(100vh - 130px) !important;
            min-height: calc(100vh - 130px) !important;
        }
    `],
    template: `
        <mat-toolbar color="primary" id="picker-menu">
            <button mat-button 
                    *ngIf="!isLargeScreen() && !isTopicRoute && !isItemRoute" 
                    class="menu-button left-menu-button" 
                    (click)="toggleSidebar(sideNav)">
                <i class="big-icon fa fa-bars"></i>
            </button>
            <span fxFlex *ngIf="!isLargeScreen() && (isTopicRoute || isItemRoute)" class="menu-button left-menu-button"></span>
            <app-nav [digestHome]="isPublicTopics && !currentUser()"
                     [class]="{ 'small-ff': !isLargeScreen() }"></app-nav>
            <span fxFlex></span>
            <logo *ngIf="showLogo && !(!isLargeScreen() && isPublicTopics && !currentUser())"></logo>
            <span fxFlex></span>
            <create-topic-link></create-topic-link>
            <login-button></login-button>
            <register-button></register-button>
            <app-right-nav [hasCurrentUser]="!!currentUser()"></app-right-nav>
        </mat-toolbar>
        <mat-toolbar *ngIf="isTopicRoute && ! focusedItemContext">
            <span fxFlex></span>
            <button class="menu-button" mat-icon-button matTooltip="Close" (click)="goBack()"><i class="big-icon fa fa-times"></i></button>
        </mat-toolbar>
        <nav-bar [hidden]="!currentUser() || isTopicRoute || isItemRoute"></nav-bar>
        <mat-sidenav-container fxFill class="sidebar" [class]="isTopicRoute ? 'short-sidenav': 'tall-sidenav'">
            <mat-sidenav [mode]="isLargeScreen() ? 'side' : 'over'" opened="true" class="browse-nav" #sideNav>
                <div fxLayout="column" style="min-height: calc(100vh - 68px)">
                    <div *ngIf="currentUser() && !isPublicTopics" fxFlex fxLayout="row" class="menuButtonHolder"  [ngClass]="{ 'selected-side-menu-button': isGroups }">
                        <menu-button fxFlex icon="group" label="Groups" [link]="['/browse', 'groups']"></menu-button>
                    </div>
                    <div fxFlex fxLayout="row" class="menuButtonHolder"  [ngClass]="{ 'selected-side-menu-button': isTeamTopics }">
                        <menu-button fxFlex icon="my_location" [label]="tenantName" [link]="['/browse', 'team']"></menu-button>
                    </div>
                    <mat-expansion-panel [expanded]="isTeamTopics || selectedCategoryId && !selectedCatalog" 
                                        *ngIf="taxonomy.length > 1" 
                                        class="full-width" 
                                        style="background-color: inherit; box-shadow: none;">
                        <category-card *ngFor="let category of taxonomy"
                                    [title]="category.title"
                                    [distinctToggle]="true"
                                    [showToggle]="!!category.subcategories.length"
                                    [isOpen]="categorySelectedMap[category.id]"
                                    (toggleOpen)="categorySelectedMap[category.id] = !categorySelectedMap[category.id]"
                                    (select)="selectCategory(category.id)"
                                    [ngClass]="{'selected-menu-card': selectedCategoryId === category.id }">
                            <div *ngFor="let subCategory of category.subcategories">
                                <button mat-button
                                        class="category-menu-button"
                                        [ngClass]="{'selected-menu-item': selectedCategoryId === subCategory.id }"
                                        (click)="selectCategory(subCategory.id)">{{subCategory?.title}}</button>
                            </div>
                        </category-card>
                    </mat-expansion-panel>
                    <div *ngFor="let catalog of browseableCatalogs" fxLayout="column" fxLayoutAlign="center">
                        <div fxFlex fxLayout="row" class="menuButtonHolder"  [ngClass]="{ 'selected-side-menu-button': selectedCatalog === catalog.catalogId && !selectedCategoryId }">
                            <menu-button fxFlex icon="cloud_queue" [label]="catalog.label" [link]="['/browse', 'catalog', catalog.catalogId]"></menu-button>
                        </div>
                        <mat-expansion-panel 
                            [expanded]="selectedCatalog === catalog.catalogId" 
                            *ngIf="catalogTaxonomies[catalog.catalogId]?.length > 1" 
                            class="full-width" 
                            style="background-color: inherit; box-shadow: none;">
                            <category-card *ngFor="let category of catalogTaxonomies[catalog.catalogId]"
                                            [title]="category.title"
                                            [distinctToggle]="true"
                                            [showToggle]="!!category.subcategories.length"
                                            [isOpen]="categorySelectedMap[category.id]"
                                            (toggleOpen)="categorySelectedMap[category.id] = !categorySelectedMap[category.id]"
                                            (select)="selectCateglogCategory(catalog.catalogId, category.id)"
                                            [ngClass]="{'selected-menu-card': selectedCategoryId === category.id }">
                                    <div *ngFor="let subCategory of category.subcategories">
                                        <button mat-button
                                                class="category-menu-button"
                                                [ngClass]="{'selected-menu-item': selectedCategoryId === subCategory.id }"
                                                (click)="selectCateglogCategory(catalog.catalogId, subCategory.id)">{{subCategory?.title}}</button>
                                    </div>
                            </category-card>
                        </mat-expansion-panel>
                    </div>
                    <span fxFlex></span>
                    <mat-toolbar *ngIf="isPublicTopics" style="height: 33px;">
                        <a color="primary" mat-button target="_blank" href="https://attensa.com/tc">About Attensa</a>
                        <a color="primary" mat-button target="_blank" href="https://attensa.com/tcfaq">FAQs</a>
                    </mat-toolbar>
                </div>
            </mat-sidenav>
            <a *ngIf="introDetails && isLargeScreen()"
               target="_blank" 
               [href]="introDetails.browseHeaderImageLink">
                <img [src]="introDetails.browseHeaderImageUrl" style="max-width: calc(100vw - 300px);">
            </a>
            <div *ngIf="(currentUser() || isPublicTopics) && !isTopicRoute && !isItemRoute && !isGroups && !isHome" style="height: 65px; background: whitesmoke; padding-left: 15px;">
                <browse-search ></browse-search>
                <div fxFlex fxFlexLayout="row" fxLayoutAlign="center center">
                    <span fxFlex></span>
                    <button *ngIf="isPublicTopics && !currentUser()" mat-raised-button style="height: 40px; color: #EA933E; font-weight: bold;" (click)="sampleBriefingHelp()">See A Sample Briefing</button>
                    <span fxFlex="20px"></span>
                </div>
            </div>
            <nav mat-tab-nav-bar *ngIf="(currentUser() || isPublicTopics) && !isGroups && !isTopicRoute && !isItemRoute && !isSearchRoute && !isFeatured && !isHome">
                <a mat-tab-link 
                   (click)="linkTo('title', 'asc')"
                   [active]="currentSort === 'title' || (!currentSort && !isGroups && !isOwnedTopics && !isNewTopics)">All</a>
                <a mat-tab-link 
                   (click)="goToNew()"
                   [active]="isNewTopics">New</a>
                <a *ngIf="currentUser()"
                   mat-tab-link 
                   (click)="linkTo('followersCount', 'desc')"
                   [active]="currentSort === 'followersCount'">Most Popular</a>
                <a *ngIf="!selectedCatalog && currentUser()"
                   mat-tab-link 
                   [routerLink]="['/browse/mine']"
                   [active]="isOwnedTopics">Topics I Manage</a>
            </nav>
            <router-outlet></router-outlet>
            <mat-sidenav [autoFocus]="false" mode="over" position="end" #rightSideNav (closedStart)="closingTime()">
                <item-viewer *ngIf="focusedItemContext" 
                             [itemContext]="focusedItemContext"
                             [curating]="focusedItemContext?.isCuration"
                             (close)="close()"></item-viewer>
                <div *ngIf="focusedItemEditContext">
                    <item-post [itemEditContextModel]="focusedItemEditContext"
                               (done)="close(100)"></item-post>
                </div>
            </mat-sidenav>
        </mat-sidenav-container>
    `
})
export class BrowseRootComponent implements OnDestroy {
    introDetails: { browseHeaderImageUrl: string, browseHeaderImageLink: string };
    @ViewChild('rightSideNav', { static: true }) rightSideNav;
    focusedItemContext: any;
    focusedItemEditContext: ItemEditContextModel;
    cleanupTime = new Subject<void>();
    isCategoryRoute: boolean = false;
    isTopicRoute: boolean = false;
    isItemRoute: boolean = false;
    isSearchRoute: boolean = false;
    selectedCategoryId: string;
    mediaSubscription: Subscription;
    routerEventsSubscription: Subscription;
    taxonomy = [];
    categorySelectedMap: object = {};
    @ViewChild('sideNav', { static: true }) sideNav;
    tenantName: string;
    ownedTopics: any;
    isOwnedTopics: boolean;
    isNewTopics: boolean;
    isGroups: boolean;
    isTeamTopics: boolean;
    showLogo: boolean;
    isPublicTopics: boolean;
    showMyTopics: boolean;
    browseableCatalogs: any[];
    catalogTaxonomies = {};
    selectedCatalog: any;
    currentSort: any;
    tenant: any;
    isHome: boolean;
    isFeatured: boolean;

    constructor(private itemService: ItemService,
                permissionService: PermissionService,
                taxonomyService: TaxonomyService,
                private userService: UserService,
                utilService: UtilService,
                private media: MediaObserver,
                private route: ActivatedRoute,
                private router: Router,
                private routingHistoryService: RoutingHistoryService,
                private storeHelper: StoreHelper) {
        this.itemService.focusedItemEdit.pipe(takeUntil(this.cleanupTime))
        .subscribe(context => {
            this.focusedItemEditContext = context;
            if (context) {
                this.rightSideNav?.open();
            } else {
                this.rightSideNav?.close();
            }
        });
        
        this.itemService.focusedItem.pipe(takeUntil(this.cleanupTime))
        .subscribe(item => {
            this.focusedItemContext = item;
            if (item) {
                this.rightSideNav?.open();
            } else {
                this.rightSideNav?.close();
            }
        });

        this.router.events.pipe(
            filter(() => !!this.tenant.settings.browseHeaderImageUrl),
            filter(e => e instanceof NavigationEnd),
            tap((e: NavigationEnd) => this.isHome = e.urlAfterRedirects === '/browse/home'),
            tap((e: NavigationEnd) => this.isFeatured = e.urlAfterRedirects?.startsWith('/browse/featured?') || e.urlAfterRedirects === '/browse/featured'),
            map(() => this.isFeatured ? 
                {
                    browseHeaderImageUrl: this.tenant.settings.browseHeaderImageUrl,
                    browseHeaderImageLink: this.tenant.settings.browseHeaderImageLink
                } : 
                null),
            takeUntil(this.cleanupTime)
        ).subscribe(details => this.introDetails = details);

        this.route.data.pipe(first()).subscribe(data => {
            this.isPublicTopics = data.tenant.settings.publicTopics === 'true'
            if (this.currentUser() || this.isPublicTopics) {
                this.browseableCatalogs = data.tenant.availableCatalogs.filter(catalog => catalog.browsingEnabled);
                this.browseableCatalogs.forEach(catalog => {
                    taxonomyService.getCatalogTaxonomy(catalog.catalogId, {filterEmpty: true}).pipe(first())
                    .subscribe(catalogTaxonomy => this.catalogTaxonomies[catalog.catalogId] = catalogTaxonomy);
                });
            }
            if (this.currentUser()) {
                this.showMyTopics = permissionService.currentUserCanCreateStream();
            }
            const hideCategories:boolean = data.tenant.settings.hideCategories === 'true';
            this.showLogo = _.isEmpty(data.tenant.settings.logoUrl);
            this.tenant = data.tenant;
            this.tenantName = data.tenant.settings.title || 'Team Topics';
            this.taxonomy = data.taxonomy.filter(category => !hideCategories || category.id === 'uncategorized');
            if(hideCategories && !_.find(this.taxonomy, {id: 'uncategorized'})){
                this.taxonomy.push({id: 'uncategorized', title: 'Uncategorized', subcategories: []});
            }
            this.setCategorySelection();
            this.configureSidebar();
        });
        this.route.queryParams.pipe(takeUntil(this.cleanupTime)).subscribe((params) => this.currentSort = params.sort);
        this.mediaSubscription = media.media$.subscribe(() => this.configureSidebar());
        this.routerEventsSubscription = this.router.events.subscribe(() => {
            this.isTopicRoute = utilService.hasUrlSeg('topics');
            this.isItemRoute = utilService.hasUrlSeg('items');
            this.isSearchRoute = utilService.hasUrlSeg('search');
            this.isCategoryRoute = utilService.hasUrlSeg('categories');
            this.isOwnedTopics = utilService.hasUrlSeg('mine');
            this.isNewTopics = utilService.hasUrlSeg('new');
            this.isGroups = utilService.hasUrlSeg('groups');
            this.isTeamTopics = utilService.hasUrlSeg('team') || utilService.hasUrlSeg('mine');
            this.setCategorySelection();
            this.configureSidebar();
        });
    };

    isDetailRoute() : boolean{
        return this.isCategoryRoute || this.isTopicRoute || this.isItemRoute || this.isSearchRoute;
    }

    configureSidebar() : void {
        if (this.sideNav) {
            if(this.media.isActive('xs') || this.isTopicRoute || this.isItemRoute || this.isSearchRoute){
                setTimeout(() => this.sideNav.close());
            }else if(!this.isDetailRoute() || (!(this.isItemRoute || this.isTopicRoute) && !this.media.isActive('xs') )){
                setTimeout(() => this.sideNav.open());
            }
        }
    };

    currentUser = () => this.userService.getCurrentUser();

    toggleSidebar(sidebar) : void {
        sidebar.toggle();
    }

    private ensureParentCategoryOpen(){
        this.taxonomy.forEach(category => {
            category.subcategories.forEach(subcategory => {
                if(subcategory.id === this.selectedCategoryId){
                    this.categorySelectedMap[category.id] = true;
                }
            });
        });
    };

    childSubUrl(): string {
        const childUrl = this.route.snapshot.firstChild.url;
        return childUrl[0].path === 'catalog' ? childUrl.slice(0, 2).map(url => url.path).join('/') : 'team';
    }

    goToNew() {
        let child = this.route.firstChild;
        while(child.firstChild) {
            child = child.firstChild;
        }
        this.router.navigate([`./new`], { relativeTo: child });
    }

    private setCategorySelection() {
        this.selectedCategoryId = undefined;
        this.selectedCatalog = undefined;
        let route = this.route;
        do {
            const params = route.snapshot && route.snapshot.params
            if (params && params.categoryId) {
                this.selectedCategoryId = params.categoryId;
                this.ensureParentCategoryOpen();
            }
            if (params && params.catalogId) {
                this.selectedCatalog = params.catalogId;

            }
            route = route.firstChild;
        } while(route);
    }

    goBack() {
        if (this.isSearchRoute) {
            const route = _.findLast(this.routingHistoryService.getHistory(), it => !it.includes('browse/search'));
            this.router.navigateByUrl(route || '/browse');
        } else if(!this.currentUser() && !this.isPublicTopics) {
            this.router.navigateByUrl('/browse/team'); 
        } else {
            let curRoute = this.route;
            while(curRoute.firstChild){
                curRoute = curRoute.firstChild;
            }
            const isPost = curRoute.snapshot.url[0]?.path === 'post';
            this.router.navigate([isPost ? '../' : '../../'], { relativeTo: curRoute });
        }
    }

    selectCategory(categoryId){
        this.storeHelper.update('browseIntroCleared', true);
        return this.router.navigate(['/browse', 'categories', categoryId]);
    };

    selectCateglogCategory(catalogId, categoryId) {
        this.storeHelper.update('browseIntroCleared', true);
        return this.router.navigate(['/browse', 'catalog', catalogId, 'categories', categoryId]);
    }

    isCatalogSelected(catalogId) {
        return false; // TODO FIXME
    }

    isLargeScreen() {
        return !this.media.isActive('xs');
    };

    linkTo(sort: string, sortDirection: string) {
        this.router.navigate([`/browse/${this.childSubUrl()}`], { queryParams: { sort, sortDirection }});
    }

    closingTime(): void {
        this.itemService.itemClosing.next();
    }

    close(wait = 0): void {
        setTimeout(() => this.rightSideNav.close(), wait);
    }

    sampleBriefingHelp(): void {
        const helpHeroTourId = 'blIuCPkwyU';
        this.userService.helpHero().startTour(helpHeroTourId);
    }

    ngOnDestroy() {
        this.cleanupTime.next();
        this.cleanupTime.complete();
        [this.mediaSubscription, this.routerEventsSubscription].forEach(sub => sub ? sub.unsubscribe() : null);
    };
}
